export function limitIndividualRisk(risk: number | string | undefined): number | string {
  if (risk == null || (typeof risk === 'string' && isNaN(Number(risk)))) return 'N/A';

  const riskNumber = Number(risk);
  if (riskNumber > 60) return '>60%';
  if (riskNumber < 0.1) return '<0.1%';

  return riskNumber;
}
